import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-two-about',
  templateUrl: './agency-two-about.component.html',
  styleUrls: ['./agency-two-about.component.scss']
})
export class AgencyTwoAboutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
